import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import db from "../../../lib/localforage";

import { filterGoals } from "../utils/filterGoals";

import { selectGoals, setGoals } from "../goalsSlice";

export const useGoals = (filterBy?: string) => {
  const dispatch = useDispatch();

  const goals = useSelector(selectGoals);

  useEffect(() => {
    db.getItem("goals").then((response: any) => {
      if (response) {
        dispatch(setGoals(JSON.parse(response)));
      }
    });
  }, [dispatch]);

  useEffect(() => {
    db.setItem("goals", JSON.stringify(goals));
  }, [goals]);

  return filterBy ? filterGoals({ goals, filterBy }) : goals;
};
